<template>
    <v-form
        ref='form'
        v-model='valid'
        lazy-validation
        @submit.prevent='addResident(model)'>
        <InitialLoading :init-loading='loading'/>
        <v-container>
            <v-row justify='center'>
                <v-col cols='12' md='8'>
                    <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>دعوت مستاجر</h3>
                    <v-alert
                        text
                        border='left'
                        prominent
                        color='info' class='mx-auto mb-5'>
                        <v-card-text class='px-0 py-0'>
                            <div>
                                <v-icon color='info' class='ml-1'>mdi-alert-circle-outline</v-icon>
                                <span class='font-weight-bold text--primary'>نکات مهم :</span>
                                <span class='text--primary'>بخشی از هزینه های مجموعه مربوط به مستاجر است با دعوت مستاجر او را از این هزینه ها به راحتی آگاه کنید</span>
                            </div>
                        </v-card-text>
                    </v-alert>
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                            <tr v-if='unit.apartment.type !=="TOWN"' class='intro transparent text-center'>
                                <td>
                                    <div>{{ unit.number }}</div>
                                    <label>واحد</label>
                                </td>
                                <td>
                                    <v-divider vertical />
                                </td>
                                <td>
                                    <div>{{ unit.floor }}</div>
                                    <label>طبقه</label>
                                </td>
                            </tr>
                            <tr v-else class='intro transparent text-center'>
                                <td>
                                    <div>قطعه</div>
                                </td>
                                <td>
                                    <v-divider vertical />
                                </td>
                                <td>
                                    <div>{{ unit.name }}</div>
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-divider />
                </v-col>
                <v-col cols='12' md='8'>
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                            <tr class='transparent'>
                                <td class='text-left'>مجموعه</td>
                                <td class='font-weight-bold'>{{ unit.apartment.title }}</td>
                            </tr>
                            <tr class='transparent'>
                                <td class='text-left'>تلفن</td>
                                <td class='font-weight-bold'>
                                    <v-icon icon class='ml-2'>mdi-card-account-phone</v-icon>
                                    <span>
										<a :href="'tel:'+unit.telephone" target='_blank'>{{ unit.telephone }}</a>
									</span>
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-col cols='12' md='8'>
                    <v-text-field
                        v-model='model.name'
                        :rules='rules.name'
                        required
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>نام و نام خانوادگی
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols='12' md='8'>
                    <v-text-field
                        v-model='model.phone'
                        :rules='rules.phone'
                        type='number'
                        required
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>شماره تلفن همراه
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols='12' md='8'>
                    <v-btn
                        block
                        color='primary'
                        type='submit'
                        @click='validate'
                        :disabled='!valid'
                    >
                        ثبت
                    </v-btn>
                    <v-btn
                        outlined
                        class='mt-2'
                        block
                        name='cancel'
                        @click='goBack'
                    >انصراف
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
            v-model='dialog'
            width='500'
        >
            <v-card>
                <v-card-title class=''>تایید دعوت مستاجر واحد</v-card-title>
                <v-card-text>
                    <p>
                        در صورت تایید شما {{ model.name }} با شماره تلفن همراه {{ model.phone }} به لیست مستاجران دعوت
                        شده به این واحد افزوده می شود.
                    </p>
                </v-card-text>

                <v-card-actions class='d-flex justify-space-between'>
                    <v-btn
                        outlined
                        name='accept'
                        color='green darken-1'
                        @click='submitNewResident'
                    >
                        تایید میکنم
                    </v-btn>
                    <v-btn
                        outlined
                        name='cancel'
                        @click='dialog= false'
                    >
                        لغو درخواست
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
    import axios from 'axios';
    import { mapActions, mapState } from 'vuex';
    import InitialLoading from '@/components/initialLoading';

    export default {
        name: 'Form',
        components: { InitialLoading },
        data: () => ({
            role: '',
            valid: true,
            apartment_id: null,
            unit_id: null,
            model: {
                name: '',
                phone: '',
                unit_floor: '',
                unit_number: '',
                unit_telephone: ''
            },
            unit: {
                apartment: {}
            },
            rules: {
                name: [
                    v => !!v || 'نام و نام خانوادگی اجباری میباشد',
                    v => !!v && v.length > 1 ? true : 'نام و نام خانوادگی باید بیشتر از ۱ حرف باشد'
                ],
                phone: [
                    v => !!v || 'شماره تلفن همراه اجباری میباشد',
                    v => /^09\d{2}\d{7}$/.test(v) ? true : 'شماره تلفن صحیح نمیباشد'
                ]
            },
            loading: true,
            dialog: false
        }),

        methods: {
            goBack() {
                this.$store.commit('goBack');
                return this.$router.replace(this.$store.state.history.page);
            },
            validate() {
                this.$refs.form.validate();
            },
            // checkPermission(apartment_id) {
            //     this.role = this.roles[apartment_id];
            //     if (this.role !== 'MANAGER') {
            //         //todo: redirect to setting
            //     }
            // },

            // get units of apartment => bms/unit.js
            async fetchUnitData() {
                await axios
                    .get(`/api/apartments/${this.apartment_id}/units/${this.unit_id}`)
                    .then(({ data }) => {
                        if (data.unit === null) {
                            this.$router.push({ name: 'NotFound' });
                        }
                        this.unit = data.unit;

                    }).catch(err => {
                        if (err.response.data.name === 'CastError') {
                            this.$router.push({ name: 'NotFound' });
                        }
                        console.error(err);
                    });
            },

            // assign user to unit => bms/unit.js
            async submitNewResident() {
                this.loading = true;
                this.model.isOwner = false;
                this.model.unit_number = this.unit.number;
                this.model.unit_floor = this.unit.floor;
                this.model.unit_name = this.unit.name;
                this.model.unit_telephone = this.unit.telephone;
                await axios
                    .post(
                        `/api/apartments/${this.apartment_id}/units/assign/${this.unit_id}`,
                        this.model
                    )
                    .then(async ({ data }) => {
                        this.dialog = false;
                        let message = 'مستاجر ثبت شد';
                        await this.$snackbar.showMessage({ content: message, color: 'success' });
                        this.loading = false;
                        await this.$router.push({
                            name: 'Unit',
                            params: data.unit._id
                        });
                    })
                    .catch(async (err) => {
                        this.dialog = false;
                        let message = 'خطا در دریافت اطلاعات از سرور';
                        if (err) {
                            const errResp = err.response;
                            if (errResp.status === 409 && errResp.data.type === 'duplicate_user_resident') message = `${this.model.name} با شماره تلفن ${this.model.phone} قبلا به عنوان مستاجر این واحد ثبت شده است.`;
                            if (errResp.status === 409 && errResp.data.type === 'duplicate_user_owner') message = `${this.model.name} با شماره تلفن ${this.model.phone} قبلا به عنوان مالک این واحد ثبت شده است.`;
                            await this.$snackbar.showMessage({
                                content: message,
                                color: 'warning',
                                timeout: 7000
                            });
                            this.loading = false;
                        } else {
                            await this.$snackbar.showMessage({
                                content: message,
                                color: 'warning',
                                timeout: 7000
                            });
                            this.loading = false;
                        }
                    });
            },
            addResident() {
                this.dialog = true;
            },
            ...mapActions(['setRole', 'showBreadCrumbs', 'setBreadCrumbsTemp'])

        },
        computed: {
            ...mapState(['roles'])
        },
        created: async function() {
            this.apartment_id = this.$route.params.apartment_id;
            this.unit_id = this.$route.params.unit_id;
            // this.checkPermission(this.apartment_id);
            await this.fetchUnitData();
            let href = window.location.pathname + window.location.search;
            await this.setBreadCrumbsTemp({
                key: 'residentForm',
                value: {
                    text: `دعوت مالک`,
                    href: href
                }
            });
            this.loading = false;
        },
        async updated() {
            await this.showBreadCrumbs(['home', 'apartmentDetail', 'unitList', 'unitDetail', 'ownerForm']);
        }
    };
</script>

<style lang='scss'>
    .intro {
        td {
            text-align: center;

            div {
                font-size: 28px !important;
                line-height: 1;
                margin-bottom: 0;
            }

            label {
                font-size: 12px;
                display: block;
            }
        }
    }
</style>